import { useEffect, useState } from 'react';
import { usePrevious } from 'app/infrastructure/hooks';
import { Configuration } from 'app/components/metro-line/types';
import { FavouriteItemValidation } from '../types-store';
import { FavouriteSectionType } from './types';

export const useInvalidSection = (
  configuration: Configuration<FavouriteSectionType>[],
  validation: FavouriteItemValidation
): [Configuration<FavouriteSectionType>, React.Dispatch<React.SetStateAction<Configuration<FavouriteSectionType>>>] => {

  const [invalidSection, updateInvalidSection] = useState(configuration.find(configurationSection => !configurationSection.isValid));
  const previousValidation = usePrevious(validation);

  useEffect(() => {
    if (invalidSection === undefined && validation !== previousValidation) {
      updateInvalidSection(configuration.find(configurationSection => !configurationSection.isValid));
    }
  }, [configuration, validation]);

  return [invalidSection, updateInvalidSection];
};
